
import { cartAdd } from '@process-creative/slate-theme-tools';
import { bindAssignedElements } from './utils';


export const CLASS_OPEN = 'is-bundle-builder-open';

const template = document.createElement('template');
template.innerHTML = `
  <style>
    :host {
      display: block;
      background: #F5F2F0;
      padding: 1rem 1.25rem 1.25rem;
      position: relative;
      box-shadow: 0 0 1.875rem #f5f2f0;
      z-index: 1;
      position: sticky;
      bottom: 0;
      transition: all 1.4s cubic-bezier(.16,1,.3,1);
      transform: translateY(100%);
    }

    :host(.summary-in-view) {
      position: sticky;
      bottom: 0;
      transform: translateY(0%);
    }

    .wrapper {
      border-radius: 1.5rem;
      background: #FCFCFB;
      padding: 1.5rem 1.25rem 1.25rem;
    }

    .subtotal {
      display: flex;
      justify-content: space-between;
      color: #163021;
      font-family: Recoleta;
      font-size: 1.125rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.5rem;
      font-family: Recoleta,sans-serif;
      margin-bottom: 1rem;
    }

    .disclaimer-wrapper {
      display: flex;
      align-items: flex-start;
      margin-bottom: 1rem;
      align-items: center;
    }

    .disclaimer-check {
      margin-right: 0.5rem;
      cursor: pointer;
    }

    .disclaimer-label {
      cursor: pointer;
      line-height: 1.25;
    }

    .subtotal p {
      margin: 0;
    }

    .add-to-cart[disabled] {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .add-to-cart {
      border-radius: 1rem;
      background: #3F7355;
      padding: 1rem 1.5rem;
      width: 100%;
      color: #FCFCFB;
      font-size: .875rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1.25rem;
      letter-spacing: .0175rem;
      border: none;
      font-family: TTNorms Font, Helvectica, sans-serif;
      cursor: pointer;
      transition: all cubic-bezier(.16,1,.3,1) .6s;
    }

    @media only screen and (min-width: 1100px) {

      :host {
        grid-column: 1 / 2;
        padding: 0;
        width: calc(100vw - 40.75rem);
        box-shadow: none;
        padding-bottom: 46px;
        margin-top: 64px;
        border-radius: 2rem;
      }

      .wrapper {
        padding: 2.25rem 3rem;
        border-radius: 2rem;
      }

      .subtotal {
        font-size: 1.5rem;
        line-height: 2rem;
        margin-bottom: 1.25rem;
      }

      .add-to-cart {
        font-size: 1rem;
        line-height: 1.5rem;
        padding: 1.125rem 2rem;
        letter-spacing: 0;
      }

      .add-to-cart:hover {
        border-color: #f5f2f0;
        color: #163021;
        background-color: #F1EBE7;
      }
  
    }

    @media only screen and (min-width: 1750px) {

      :host {
        width: calc(100vw - 56rem);
      }

      .add-to-cart {
        padding: 1.1875rem 2rem 1.0625rem;
        letter-spacing: .025rem;
        font-size: 1.25rem;
        line-height: 1.75rem;
      }
    }
  </style>

  <div class="wrapper" part="root">
    <div class="subtotal">
      <p>Subtotal</p>
      <p class="subtotal-amount"></p>
    </div>
    <div class="disclaimer-wrapper">
      <input id="disclaimer" value="true" class="disclaimer-check" type="checkbox">
      <label for="disclaimer" class="disclaimer-label">Check your specs! Double check your measurements and custom selections to ensure a hassle free experience</label>
    </div>
    <button class="add-to-cart" disabled>
      Add to cart
    </button>
  </div>
`;


export class CustomiserAddCart extends HTMLElement {
  private priceEl:HTMLElement|null|undefined;
  private disclaimerCheck:HTMLInputElement|null|undefined;
  private addToCartBtn:HTMLButtonElement|null|undefined;

  // private disclaimerIsChecked:boolean = false;

  constructor() {
    super();

    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.priceEl = this.shadowRoot?.querySelector('.subtotal-amount');
    this.disclaimerCheck = this.shadowRoot?.querySelector('.disclaimer-check');

    this.addToCartBtn = this.shadowRoot?.querySelector('.add-to-cart');
    this.addToCartBtn?.addEventListener('click', this.handleChange.bind(this));

    this.disclaimerCheck?.addEventListener('change', this.handleDisclaimerCheck.bind(this))


  }

  private handleDisclaimerCheck(e) {
    const value = this.disclaimerCheck?.checked;
    this.addToCartBtn?.toggleAttribute('disabled', !value);

  }

  public updateFinalPrice(price) {
    if (this.priceEl)
      this.priceEl.textContent = `$${price}`;
  }

  handleChange() {
    if (!this.addToCartBtn) return;

    const evt = new CustomEvent('add_to_cart', {
      detail: {},
      bubbles: true,
      composed: true
    });

    this.dispatchEvent(evt);
  }

  public setAddToCartLabel(label:string,disableBtn:boolean) {
    if (this.addToCartBtn) {
      if (disableBtn) {
        this.addToCartBtn.setAttribute('disabled', 'disabled');
      } else {
        this.addToCartBtn.removeAttribute('disabled');
      }
      this.addToCartBtn.innerText = label;
    }
  }

  public async addItemToCart(variantID:string,properties:any,quantity:number) {
    if (!variantID) return;

    this.setAddToCartLabel('Adding...',true);

    try {
      await cartAdd({
        items: [{
          id: parseInt(variantID),
          quantity: quantity,
          properties: properties
        }]
      });

      setTimeout(() => {
        this.setAddToCartLabel('Added',true);
      }, 500);
      
      setTimeout(() => {
        this.setAddToCartLabel('Add to cart',false);
      }, 1500);
    } catch (e) {
      console.error('Failed to add to cart.');
      return;
    }
  }
}

if (!customElements.get('customiser-add-cart')) {
  customElements.define('customiser-add-cart', CustomiserAddCart);
}